import { useCallback, useEffect, useState } from "react";

import type { UseScrollIndicatorProps, UseScrollIndicatorReturn } from "./types.ts";

export const useScrollIndicator = ({
  activeSidebarTab,
  itemCount,
  panelRef,
}: UseScrollIndicatorProps): UseScrollIndicatorReturn => {
  const [showOrderItemsScrollIndicator, setShowOrderItemsScrollIndicator] = useState(false);

  const updateOrderItemsScrollIndicator = useCallback(() => {
    const list = panelRef.current;
    if (!list || activeSidebarTab !== "items") {
      setShowOrderItemsScrollIndicator(false);
      return;
    }

    const canScroll = list.scrollHeight > list.clientHeight + 4;
    const atBottom = list.scrollHeight - list.scrollTop <= list.clientHeight + 4;
    setShowOrderItemsScrollIndicator(canScroll && !atBottom);
  }, [activeSidebarTab, panelRef]);

  useEffect(() => {
    updateOrderItemsScrollIndicator();
  }, [activeSidebarTab, itemCount, updateOrderItemsScrollIndicator]);

  const handleOrderItemsScrollIndicatorClick = useCallback(() => {
    const list = panelRef.current;
    if (!list) return;

    list.scrollBy({ top: Math.max(list.clientHeight * 0.75, 80), behavior: "smooth" });
  }, [panelRef]);

  return {
    showOrderItemsScrollIndicator,
    updateOrderItemsScrollIndicator,
    handleOrderItemsScrollIndicatorClick,
  };
};
